<template>
  <span class="text-nowrap" v-if="meta">
    <!-- <span v-if="isZip">
      <span aria-hidden="true" :class="'fa ' + mimeIcon"></span> <strong>ZIP</strong> 
    </span> -->
    <span v-if="isVideo">
      <!-- <span aria-hidden="true" :class="'fa ' + mimeIcon"></span> <strong>VID</strong><span class="d-block mt-2"> -->
      <span class="d-block mt-2">
        <span
          class="d-flex"
          v-for="(val, index) in metaData"
          :key="index"
        >
          {{ $t('theme.' + val.key) }}:{{ "\xa0" }}<span class="text-nowrap">{{ val.value }}</span>
        </span>
      </span>
    </span>
    <!-- <span v-if="isObj">
      <span aria-hidden="true" :class="'fa fa-unity'"></span> <strong>OBJ3D</strong>
    </span>
    <span v-if="isStep">
      <span aria-hidden="true" :class="'fa fa-unity'"></span> <strong>STP3D</strong>
    </span> -->
    <span v-if="isImage">
      <!-- <span aria-hidden="true" :class="'fa ' + mimeIcon"></span> <strong>IMG</strong> -->
      <span class="d-block mt-2">
        <span
          class="d-flex"
          v-for="(val, index) in metaData"
          :key="index"
        >
          {{ $t('theme.' + val.key) }}:{{ "\xa0" }}<span class="text-nowrap">{{ val.value }}</span>
        </span>
      </span>
    </span>
    <span v-if="isPdf">
      <!-- <span aria-hidden="true" :class="'fa ' + mimeIcon"></span> <strong>PDF</strong> -->
      <span class="d-block mt-2">
        <span
          class="d-flex"
          v-for="(val, index) in metaData"
          :key="index"
        >
          {{ $t('theme.' + val.key) }}:{{ "\xa0" }}<span class="text-nowrap">{{ val.value }}</span>
        </span>
      </span>
    </span>
  </span>
</template>
<script>
const mimetype2fa = require('mimetype-to-fontawesome')({ prefix: 'fa-' })
export default {
  name: 'file-meta',
  props: {
    pack: {
      type: Array
    },
    extension: {
      type: String,
      default: "pdf"
    },
    mime: {
      type: String,
      default: "application/pdf"
    },
    meta: {
      type: Object,
      default: null
    },
  },
  computed: {
    mimeIcon () {
      return mimetype2fa(this.mime)
    },

    metaData () {
      let output = []

      if (this.meta.Orientation) {
        output.push({
          key: 'orientation',
          value: this.meta.Orientation
        })
      }

      if (this.meta.ColorMode) {
        output.push({
          key: 'colorMode',
          value: this.meta.ColorMode
        })
      }

      if (this.meta.ColorSpace) {
        output.push({
          key: 'colorSpace',
          value: this.meta.ColorSpace
        })
      }

      if (this.meta.ResolutionUnit) {
        output.push({
          key: 'resolutionUnit',
          value: `${this.meta.ResolutionUnit}`
        })
      }

      if (this.meta.XResolution && this.meta.YResolution) {
        output.push({
          key: 'resolution',
          value: `${this.meta.XResolution}x${this.meta.YResolution}`
        })
      }

      if (this.meta.ExifImageWidth && this.meta.ExifImageHeight) {
        output.push({
          key: 'dimensions',
          value: `${this.meta.ExifImageWidth}x${this.meta.ExifImageHeight}`
        })
      } else {
        if (this.meta.ImageWidth && this.meta.ImageHeight) {
          output.push({
            key: 'dimensions',
            value: `${this.meta.ImageWidth}x${this.meta.ImageHeight}`
          })
        }
      }

      if (this.meta.difficuly) {
        output.push({
          key: 'difficuly',
          value: `${this.meta.difficuly.level} - ${this.meta.difficuly.label}`
        })
      }

      if (this.meta.viewCount) {
        output.push({
          key: 'viewCount',
          value: `${this.meta.viewCount}`
        })
      }

      if (this.meta.definition) {
        output.push({
          key: 'definition',
          value: `${this.meta.definition.toUpperCase()}`
        })
      }

      return output
    },

    isImage () {
      if (['image/png', 'image/jpeg', 'image/jpg'].includes(this.mime)) {
        return true
      }
      return false
    },

    isPdf () {
      if (['application/pdf'].includes(this.mime)) {
        return true
      }
      return false
    },

    isVideo () {
      if (['video/mpeg'].includes(this.mime)) {
        return true
      }
      return false
    }
  }
}
</script>
